import { apis, serviceInterface } from "./config";

export const submitRequest = data => {
  return serviceInterface.post(apis.CONTENT_REQUEST, {...data}
  );
};
